import React from 'react'

import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import { Box, Stack } from '@mui/material'

import Can from 'components/Can'

import CustomerMenuItem from './CustomerMenuItem'

interface CustomerActionsMenuProps {
  status?: string
  handleClickDelete?: () => void
  handleClickArchive?: () => void
  handleClickUnarchive?: () => void
  handleOpenFichaCadastral?: () => void
  handleEnterInPortal?: () => void
  handleCopyPortalInfo?: () => void
  handleOpenHistoric?: () => void
}

const CustomerActionsMenu: React.FC<CustomerActionsMenuProps> = ({
  status,
  handleClickDelete,
  handleClickArchive,
  handleClickUnarchive,
  handleOpenFichaCadastral,
  handleEnterInPortal,
  handleCopyPortalInfo,
  handleOpenHistoric
}) => (
  <Can permission="customers:manage">
    <Stack>
      <CustomerMenuItem
        icon="delete"
        label="Excluir"
        onClick={() => {
          handleClickDelete && handleClickDelete()
        }}
      />

      {status === 'archived' ? (
        <CustomerMenuItem
          icon="archive"
          label="Desarquivar"
          onClick={() => {
            handleClickUnarchive && handleClickUnarchive()
          }}
          iconProps={{ sx: { rotate: '180deg' } }}
        />
      ) : (
        <CustomerMenuItem
          icon="archive"
          label="Arquivar"
          onClick={() => {
            handleClickArchive && handleClickArchive()
          }}
        />
      )}

      <CustomerMenuItem
        icon="accessTime"
        label="Histórico de edições"
        onClick={() => {
          handleOpenHistoric && handleOpenHistoric()
        }}
      />

      <CustomerMenuItem
        icon="listAlt"
        label="Ficha Cadastral"
        onClick={() => {
          handleOpenFichaCadastral && handleOpenFichaCadastral()
        }}
      />

      <CustomerMenuItem
        icon="login"
        label="Acessar Portal"
        onClick={() => {
          handleEnterInPortal && handleEnterInPortal()
        }}
      />

      <CustomerMenuItem
        icon={
          <Box ml="5px">
            <ContentCopyIcon sx={{ height: '20px', width: '20px' }} />
          </Box>
        }
        label="Instruções de acesso ao Portal"
        onClick={() => {
          handleCopyPortalInfo && handleCopyPortalInfo()
        }}
      />
    </Stack>
  </Can>
)

export default CustomerActionsMenu
